import { Box, Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import React from "react";
import "./SubmitPopup.scss";

const SubmitPopup = ({ openPopup, setOpenPopup, submitForm }) => {
  const handleClose = () => {
    setOpenPopup(false);
  };
  const handleSubmit = () => {
    submitForm();
    setOpenPopup(false);
  };
  return (
    <>
      <Dialog
        open={openPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box
          sx={{
            p: "20px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: "20px",
              color: "262626",
            }}
            id="alert-dialog-title"
          >
            Please confirm your submission. Once submitted, your data cannot be
            changed or edited. Are you sure you want to proceed?
          </DialogTitle>
          <DialogActions sx={{ marginTop: "20px" }}>
            <Button className="reset_btn" onClick={handleClose}>
              No
            </Button>
            <Button
              // onClick={() => submitForm()}
              className="submit_btn"
              onClick={handleSubmit}
            >
              Yes
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default SubmitPopup;
